import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
import { trackAddToCart } from '../utils/metaPixel';
export function FinalCTA() {
  return <section className="py-24 bg-gradient-to-b from-transparent to-navy-900 relative" data-id="element-40">
      <div className="container mx-auto px-4 max-w-3xl text-center" data-id="element-41">
        <FadeIn data-id="element-42">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-43">
            Si quieres dejar de sentir que el dinero manda en tu vida…
          </h2>
          <p className="text-2xl text-gold-400 font-medium mb-12" data-id="element-44">
            y quieres ser tú la que decide…
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-45">
          <p className="text-xl text-slate-300 mb-10" data-id="element-46">
            Compra "Finanzas Sin Excusas" hoy y empieza tu Día 1.
          </p>

          <a href="https://reckiva.com/cart/48040237727844:1" target="_blank" rel="noopener noreferrer" className="btn-gold w-full sm:w-auto group text-xl py-5 px-10 mb-16 inline-flex" onClick={trackAddToCart} data-id="element-47">
            Sí, quiero ordenar mis finanzas
            <ArrowRightIcon className="ml-2 w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-48" />
          </a>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-49">
          <div className="text-left bg-white/5 border border-white/10 rounded-xl p-8 max-w-2xl mx-auto" data-id="element-50">
            <p className="text-gold-500 font-bold mb-2" data-id="element-51">P.D.</p>
            <p className="text-lg text-slate-300 mb-4" data-id="element-52">
              No necesitas ganar el doble. Necesitas un sistema que te dé paz.
            </p>
            <p className="text-lg text-white font-medium italic" data-id="element-53">
              Empieza hoy. En 60 días vas a mirar atrás y decir: "¿Por qué no
              hice esto antes?"
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}